import axios from 'axios';
import storage from './storage';
import getConfig from '../config';
import { runtimeMappings } from './runtime-mappings';
import { getStageMonitoringData } from './helpers';
import getProject from '../services/getProject';

const { backendApi, indexerApi } = getConfig();

// eslint-disable-next-line max-len
export const initialQuery = {
  runtime_mappings: { ...runtimeMappings },
  fields: [
    'currentStage',
    'parsedSquare',
    'deadline',
    'isStagesFinished',
    'shortRegion',
    'isCarbonProject',
  ],
  from: 0,
  size: 20,
  query: {
    bool: {
      must: [],
    },
  },
  sort: [],
};

export const sendRequest = async (url, method, body, authRequired, signal) => {
  const JWT = storage.get('token') || '';

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  if (authRequired) headers.append('Authorization', `Bearer ${JWT}`);

  const options = {};
  options.method = method;
  if (method !== 'GET') options.body = body;
  if (signal) options.signal = signal;
  options.headers = headers;

  try {
    const response = await fetch(url, options);

    if (response.ok) {
      if (response.status === 204) return { result: null, statusCode: response.status };
      const json = await response.json();
      return { result: json, statusCode: response.status };
    }

    return { result: null, statusCode: response.status };
  } catch (e) {
    if (e.name === 'AbortError') return { result: null, statusCode: 20 };
    return { result: null, statusCode: 502 };
  }
};

export const handleResponseStatus = (status, successFunc, failFunc) => {
  if (status >= 200 && status <= 299) return successFunc();
  if (status >= 400 && status <= 499) {
    if (status === 401) window.location.pathname = '/login';
    else return failFunc();
  }
  if (status >= 500 && status <= 599) return failFunc();
};

export const checkExistingFieldAgent = async (project, currentStageId) => {
  const { targetStageInfo, targetSampleZones } = getStageMonitoringData(project, currentStageId);

  if (!project.stages?.length || !targetStageInfo) {
    return { exist: false, error: false };
  }

  let isFiledAgentExist = {};
  const { result, statusCode } = await sendRequest(`${backendApi}/api/dashboard/sample-zone/list`, 'GET', {}, true);
  handleResponseStatus(
    statusCode,
    () => {
      if (result && result.length) {
        const assignedZone = targetSampleZones?.some((el) => !!result.find((i) => el.id === i.sample_zone_id));
        if (assignedZone) {
          isFiledAgentExist = { exist: true, error: false };
          return;
        }
      }
      isFiledAgentExist = { exist: false, error: false };
    },
    () => {
      isFiledAgentExist = { error: true };
    },
  );

  return isFiledAgentExist;
};

export function requestApi(httpMethod, url, params = {}) {
  const token = storage.get('token');

  return axios({
    method: httpMethod,
    url: `${backendApi}${url}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(params),
  }).then((res) => res.data).catch((err) => err.response.data);
}
export const getUpdatedDate = async (id) => {
  const body = {
    query: {
      bool: {
        must: [
          {
            match: {
              'project_id.keyword': id,
            },
          },
        ],
      },
    },
    _source: ['updatedAt'],
  };
  const { result } = await sendRequest(indexerApi, 'POST', JSON.stringify(body));

  return result.hits?.hits[0]._source;
};
const getProjectData = async (accountId, projectId) => {
  if (accountId) {
    const bodyReq = {
      query: {
        bool: {
          must: [
            {
              match: {
                'project_id.keyword': projectId,
              },
            },
            {
              match: {
                'signer_id.keyword': accountId.accountId,
              },
            },
          ],
        },
      },
    };
    if (projectId) {
      const dataProject = await getProject(bodyReq);
      const tokenData = dataProject.data?.hits?.hits?.length && dataProject.data?.hits?.hits[0]._source;
      if (tokenData) {
        return tokenData;
      }
    }
  }
};

export const chooseReUpdateData = async (projectId, accountId, oldData) => {
  const compareData = await getUpdatedDate(projectId);
  let reUpdateProjectData;
  if (oldData?.updatedAt !== compareData.updatedAt) {
    reUpdateProjectData = await getProjectData(accountId, projectId);
  } else reUpdateProjectData = oldData;
  return reUpdateProjectData;
};
